module.exports = __webpack_public_path__ + "static/media/mask-group-9@2x.e729891d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask-group-9@2x.png
// module id = 589
// module chunks = 1